import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/pixel';
export function FinalCTASection() {
  return <section id="comprar" className="w-full bg-dark-800 py-24 px-4 border-t border-white/5" data-id="element-71">
      <div className="max-w-4xl mx-auto text-center" data-id="element-72">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-73">
          Recuperá el control.
          <br data-id="element-74" />
          <span className="text-gold-500" data-id="element-75">Subí la intensidad.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-76">
          <strong className="text-white" data-id="element-77">Gel íntimo Gold Estimulante</strong> —
          apto para preservativos, envío gratis a todo el país y 180 días de
          garantía con cambio directo.
          <br data-id="element-78" />
          <br data-id="element-79" />
          Comprá ahora y recibilo en tu casa con{' '}
          <strong className="text-white" data-id="element-80">total discreción</strong>.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-81">
          <div className="flex items-center gap-3 mb-6" data-id="element-82">
            <span className="text-gray-500 line-through text-lg" data-id="element-83">$69.430</span>
            <span className="text-white font-black text-3xl md:text-4xl" data-id="element-84">
              $49.990
            </span>
            <span className="bg-green-500/20 text-green-400 text-xs font-bold px-2.5 py-1 rounded-full uppercase tracking-wider border border-green-500/30" data-id="element-85">
              28% OFF
            </span>
          </div>
          <motion.a href="https://argrutinas.com/cart/42974532468945:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center rounded-lg font-bold transition-all duration-300 bg-gold-500 text-dark-900 hover:bg-gold-400 shadow-gold-glow w-full md:w-auto text-lg px-10 py-5" data-id="element-86">
            Comprar ahora — $49.990 (Envío gratis + 180 días de garantía)
          </motion.a>
        </motion.div>
      </div>
    </section>;
}